import { __awaiter, __generator } from "tslib";
import { makeUrl } from "./makeUrl";
export function logEvent(name, props) {
    return __awaiter(this, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    props["source"] = "map";
                    props["$current_url"] = window.location.href;
                    return [4 /*yield*/, fetch(makeUrl("/event"), {
                            method: "POST",
                            body: JSON.stringify({
                                name: name,
                                props: props,
                            }),
                            headers: {
                                "Content-type": "application/json",
                            },
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
